(function () {
  const USD_RATE = 83.5;
  const STORAGE_KEYS = {
    announcement: 'elaMysticAnnouncementDismissed',
    currency: 'elaMysticCurrency'
  };

  function escapeHtml(str) {
    return String(str ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatINR(cents) {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(cents / 100);
  }

  function formatUSD(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format((cents / 100) / USD_RATE);
  }

  function formatPrice(cents) {
    return (localStorage.getItem(STORAGE_KEYS.currency) || 'INR') === 'USD'
      ? formatUSD(cents)
      : formatINR(cents);
  }

  function showToast(message) {
    const container = document.getElementById('toast-container');
    if (!container) return;
    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    container.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('show'));
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 300);
    }, 2400);
  }

  function collapseAnnouncementBar() {
    document.documentElement.style.setProperty('--announcement-h', '0px');
  }

  function syncAnnouncementHeight(bar) {
    document.documentElement.style.setProperty('--announcement-h', bar.offsetHeight + 'px');
  }

  function initAnnouncementBar() {
    const bar = document.getElementById('announcement-bar');
    if (!bar) return;
    if (sessionStorage.getItem(STORAGE_KEYS.announcement) === '1') {
      bar.classList.add('is-hidden');
      collapseAnnouncementBar();
    } else {
      requestAnimationFrame(() => syncAnnouncementHeight(bar));
      if (window.ResizeObserver) {
        new ResizeObserver(() => {
          if (!bar.classList.contains('is-hidden')) syncAnnouncementHeight(bar);
        }).observe(bar);
      }
    }
    const closeBtn = bar.querySelector('.announcement-bar__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        sessionStorage.setItem(STORAGE_KEYS.announcement, '1');
        bar.classList.add('is-hidden');
        collapseAnnouncementBar();
      });
    }
  }

  window.dismissBar = function dismissBar() {
    const bar = document.getElementById('announcement-bar');
    if (!bar) return;
    sessionStorage.setItem(STORAGE_KEYS.announcement, '1');
    bar.classList.add('is-hidden');
    collapseAnnouncementBar();
  };

  // Single RAF-throttled scroll handler — header.liquid inline script removed
  function initHeaderScroll() {
    const nav = document.querySelector('.nav');
    if (!nav) return;
    let lastScrollY = 0;
    let ticking = false;

    function update() {
      const scrollY = window.scrollY;
      nav.classList.toggle('scrolled', scrollY > 50);
      if (scrollY > 80) {
        nav.classList.toggle('nav--hidden', scrollY > lastScrollY);
      } else {
        nav.classList.remove('nav--hidden');
      }
      lastScrollY = scrollY;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  // Resets interval on manual dot click so auto-advance always waits a full 5s
  function initHeroSlider() {
    const slider = document.getElementById('hero-slider');
    const dots = document.querySelectorAll('#hero-dots .dot');
    if (!slider || dots.length < 2) return;
    const slides = slider.querySelectorAll('.slide');
    let index = 0;
    let intervalId;

    const render = (nextIndex) => {
      index = nextIndex;
      slides.forEach((slide, i) => slide.classList.toggle('slide--active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
    };

    const queueNext = () => {
      clearInterval(intervalId);
      intervalId = setInterval(() => render((index + 1) % slides.length), 5000);
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      render(i);
      queueNext();
    }));

    queueNext();
  }

  function setCurrency(currency) {
    localStorage.setItem(STORAGE_KEYS.currency, currency);
    document.querySelectorAll('[data-currency-toggle]').forEach((button) => {
      button.classList.toggle('active', button.dataset.currencyToggle === currency);
    });

    document.querySelectorAll('[data-money-convert]').forEach((node) => {
      const inrCents = Number(node.dataset.moneyConvert || 0);
      if (node.dataset.moneyMode === 'primary') {
        node.textContent = currency === 'USD' ? formatUSD(inrCents) : formatINR(inrCents);
      } else {
        node.textContent = currency === 'USD' ? formatINR(inrCents) : formatUSD(inrCents);
      }
    });

    document.querySelectorAll('[data-payment-copy]').forEach((node) => {
      node.textContent = currency === 'USD'
        ? 'International checkout is processed through Shopify Payments and PayPal.'
        : 'Indian checkout is processed securely via Razorpay, UPI, and cards.';
    });
  }

  function initCurrencyToggle() {
    const active = localStorage.getItem(STORAGE_KEYS.currency) || 'INR';
    document.querySelectorAll('[data-currency-toggle]').forEach((button) => {
      button.addEventListener('click', () => setCurrency(button.dataset.currencyToggle));
    });
    setCurrency(active);
  }

  function initAOS() {
    const elements = document.querySelectorAll('[data-aos]');
    if (!elements.length) return;

    const trigger = (el) => {
      const delay = Number(el.dataset.aosDelay || 0);
      setTimeout(() => el.classList.add('aos-animate'), delay);
    };

    if (window.Shopify && window.Shopify.designMode) {
      elements.forEach(trigger);
      document.addEventListener('shopify:section:load', (e) => {
        e.target.querySelectorAll('[data-aos]').forEach(trigger);
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          trigger(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01 });
    elements.forEach((element) => observer.observe(element));
  }

  function initFilters() {
    const tabs = document.querySelectorAll('[data-filter]');
    if (!tabs.length) return;
    const cards = document.querySelectorAll('[data-tags]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (b) { b.classList.remove('active'); });
        tab.classList.add('active');

        const filter = tab.getAttribute('data-filter');

        cards.forEach(function (card) {
          const tags = card.getAttribute('data-tags') || '';
          if (filter === 'all' || tags.includes(filter)) {
            card.style.display = '';
            card.style.opacity = '1';
          } else {
            card.style.display = 'none';
            card.style.opacity = '0';
          }
        });
      });
    });
  }

  function initAccordions() {
    document.querySelectorAll('.accordion-item__header').forEach((button) => {
      button.addEventListener('click', () => {
        button.closest('.accordion-item').classList.toggle('open');
      });
    });
  }

  function initProductGallery() {
    document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const wrap = thumb.closest('[data-product-gallery]');
        if (!wrap) return;
        wrap.querySelectorAll('[data-gallery-thumb]').forEach((btn) => btn.classList.remove('active'));
        thumb.classList.add('active');

        // Scroll to corresponding slide
        const slidesContainer = wrap.querySelector('.product-gallery__slides');
        if (slidesContainer) {
          const targetSlide = Array.from(slidesContainer.children).find(
            (slide) => slide.dataset.imageUrl === thumb.dataset.galleryThumb
          );
          if (targetSlide) {
            slidesContainer.scrollTo({
              left: targetSlide.offsetLeft,
              behavior: 'smooth'
            });
          }
        } else {
          const main = wrap.querySelector('[data-gallery-main]');
          if (main) {
            main.removeAttribute('srcset');
            main.removeAttribute('sizes');
            main.src = thumb.dataset.galleryThumb;
          }
        }
      });
    });

    // Sync scroll with dots indicator on mobile
    const slidesContainer = document.querySelector('.product-gallery__slides');
    const dots = document.querySelectorAll('.product-gallery__dot');
    if (slidesContainer && dots.length) {
      slidesContainer.addEventListener('scroll', () => {
        const width = slidesContainer.clientWidth;
        if (width === 0) return;
        const index = Math.round(slidesContainer.scrollLeft / width);
        const visibleDots = Array.from(dots).filter(dot => dot.style.display !== 'none');
        visibleDots.forEach((dot, idx) => {
          dot.classList.toggle('active', idx === index);
        });
      }, { passive: true });

      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          const targetSlide = slidesContainer.children[idx];
          if (targetSlide) {
            slidesContainer.scrollTo({
              left: targetSlide.offsetLeft,
              behavior: 'smooth'
            });
          }
        });
      });
    }
  }

  function initQuantityControls() {
    document.querySelectorAll('[data-qty-control]').forEach((control) => {
      control.addEventListener('click', () => {
        const target = document.querySelector(control.dataset.qtyControl);
        if (!target) return;
        const current = Number(target.value || target.textContent || 1);
        const next = Math.max(1, current + Number(control.dataset.qtyDelta));
        if (target.tagName === 'INPUT') target.value = next;
        else target.textContent = next;
      });
    });
  }

  function updateShippingProgress(totalPrice) {
    const threshold = Number(window.themeStrings?.freeShippingThreshold || 999) * 100;
    const remaining = Math.max(threshold - totalPrice, 0);
    const fill = document.querySelector('[data-shipping-progress]');
    const label = document.querySelector('[data-shipping-label]');
    if (fill) fill.style.width = `${Math.min((totalPrice / threshold) * 100, 100)}%`;
    if (label) {
      label.textContent = remaining > 0
        ? `Add ${formatINR(remaining)} more for free shipping`
        : 'You have unlocked free shipping';
    }
  }

  function renderCart(cart) {
    const countNodes = document.querySelectorAll('[data-cart-count]');
    countNodes.forEach((node) => {
      node.textContent = cart.item_count;
      node.classList.toggle('is-hidden', cart.item_count < 1);
    });

    const body = document.querySelector('[data-cart-body]');
    const subtotal = document.querySelector('[data-cart-subtotal]');
    const title = document.querySelector('[data-cart-title]');
    if (title) title.textContent = `Your Cart (${cart.item_count})`;
    if (subtotal) subtotal.textContent = formatPrice(cart.total_price);
    updateShippingProgress(cart.total_price);

    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><div>Cart</div><p>Your cart is empty</p></div>';
      return;
    }

    body.innerHTML = cart.items.map((item) => `
      <div class="cart-item">
        <div class="cart-item__img">
          ${item.featured_image ? `<img src="${escapeHtml(item.featured_image.url)}" alt="${escapeHtml(item.product_title)}">` : ''}
        </div>
        <div class="cart-item__info">
          <div class="cart-item__name">${escapeHtml(item.product_title)}</div>
          <div class="cart-item__variant">${escapeHtml(item.variant_title || '')}</div>
          <div class="cart-item__controls">
            <button class="cart-qty-btn" data-cart-change="${escapeHtml(item.key)}" data-cart-qty="${item.quantity - 1}">-</button>
            <span>${item.quantity}</span>
            <button class="cart-qty-btn" data-cart-change="${escapeHtml(item.key)}" data-cart-qty="${item.quantity + 1}">+</button>
            <button class="cart-item__remove" data-cart-change="${escapeHtml(item.key)}" data-cart-qty="0">Remove</button>
          </div>
        </div>
        <div class="cart-item__price">${formatPrice(item.final_line_price)}</div>
      </div>
    `).join('');
  }

  async function fetchCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Cart fetch failed');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  }

  window.openCart = function openCart() {
    document.getElementById('cart-overlay')?.classList.add('open');
    document.getElementById('cart-drawer')?.classList.add('open');
    fetchCart().catch(() => { });
  };

  window.closeCart = function closeCart() {
    document.getElementById('cart-overlay')?.classList.remove('open');
    document.getElementById('cart-drawer')?.classList.remove('open');
  };

  window.toggleCart = function toggleCart() {
    const isOpen = document.getElementById('cart-drawer')?.classList.contains('open');
    if (isOpen) closeCart();
    else openCart();
  };

  async function addToCart(variantId, quantity) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity || 1) })
      });
      if (!response.ok) throw new Error('Add to cart failed');
      await fetchCart();
      openCart();
      showToast(window.themeStrings?.addedToCart || 'Added to cart');
    } catch {
      showToast('Could not add to cart. Please try again.');
    }
  }

  function getRequestedQuantity(button) {
    const selector = button?.dataset.quantityInput;
    if (!selector) return Number(button?.dataset.quantity || 1);
    const input = document.querySelector(selector);
    return Number(input?.value || input?.textContent || button?.dataset.quantity || 1);
  }

  async function changeCartItem(key, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });
      if (!response.ok) throw new Error('Cart update failed');
      await fetchCart();
    } catch {
      showToast('Could not update cart. Please try again.');
    }
  }

  function initCartActions() {
    document.querySelectorAll('[data-open-cart]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        toggleCart();
      });
    });

    document.addEventListener('click', async (event) => {
      const addButton = event.target.closest('[data-add-to-cart]');
      if (addButton) {
        event.preventDefault();
        await addToCart(addButton.dataset.addToCart, getRequestedQuantity(addButton));
      }

      const buyNowButton = event.target.closest('[data-buy-now]');
      if (buyNowButton) {
        event.preventDefault();
        await addToCart(buyNowButton.dataset.buyNow, getRequestedQuantity(buyNowButton));
        window.location.href = '/checkout';
      }

      const cartChange = event.target.closest('[data-cart-change]');
      if (cartChange) {
        event.preventDefault();
        await changeCartItem(cartChange.dataset.cartChange, Number(cartChange.dataset.cartQty));
      }
    });

    fetchCart().catch(() => { });
  }

  function initMobileMenu() {
    const menu = document.getElementById('mobile-menu');
    document.querySelectorAll('[data-mobile-menu-open]').forEach((button) => {
      button.addEventListener('click', () => menu?.classList.toggle('open'));
    });
    document.querySelectorAll('[data-mobile-menu-close]').forEach((button) => {
      button.addEventListener('click', () => menu?.classList.remove('open'));
    });
  }

  async function openQuickView(handle) {
    const overlay = document.getElementById('quickview-overlay');
    const modal = document.getElementById('quickview-modal');
    if (!overlay || !modal || !handle) return;
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error('Product fetch failed');
      const product = await response.json();
      const variant = product.variants.find((item) => item.available) || product.variants[0];
      modal.querySelector('[data-qv-title]').textContent = product.title;
      modal.querySelector('[data-qv-description]').innerHTML = product.description || '';
      modal.querySelector('[data-qv-price-primary]').textContent = formatPrice(variant.price);
      modal.querySelector('[data-qv-price-alt]').textContent =
        (localStorage.getItem(STORAGE_KEYS.currency) || 'INR') === 'USD'
          ? formatINR(variant.price)
          : formatUSD(variant.price);
      modal.querySelector('[data-qv-origin]').textContent = product.vendor || 'India';
      modal.querySelector('[data-qv-image]').src = product.featured_image;
      modal.querySelector('[data-qv-add]').dataset.addToCart = variant.id;
      modal.querySelector('[data-qv-add]').dataset.quantity = '1';
      modal.querySelector('[data-qv-qty]').textContent = '1';
      overlay.classList.add('open');
      modal.classList.add('open');
    } catch {
      showToast('Could not load product. Please try again.');
    }
  }

  window.closeQuickView = function closeQuickView() {
    document.getElementById('quickview-overlay')?.classList.remove('open');
    document.getElementById('quickview-modal')?.classList.remove('open');
  };

  function initQuickView() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-quick-view]');
      if (trigger) {
        event.preventDefault();
        openQuickView(trigger.dataset.quickView).catch(() => { });
      }
    });

    document.querySelectorAll('[data-qv-qty-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const qtyNode = document.querySelector('[data-qv-qty]');
        const current = Number(qtyNode.textContent || 1);
        qtyNode.textContent = String(Math.max(1, current + Number(button.dataset.qvQtyChange)));
        const addButton = document.querySelector('[data-qv-add]');
        if (addButton) addButton.dataset.quantity = qtyNode.textContent;
      });
    });
  }

  function filterGallery(selectedValues, featuredImageUrl) {
    console.log("filterGallery invoked with selectedValues:", selectedValues, "featuredImageUrl:", featuredImageUrl);
    const thumbs = document.querySelectorAll('[data-gallery-thumb]');
    console.log("Found thumbnails count:", thumbs.length);
    if (!thumbs.length) return;

    let firstVisibleThumb = null;
    let activeThumbIsVisible = false;
    let matchedFeaturedThumb = null;

    const slides = document.querySelectorAll('.product-gallery__slide');
    const dots = document.querySelectorAll('.product-gallery__dot');
    thumbs.forEach((thumb, index) => {
      const altText = (thumb.getAttribute('data-image-alt') || '').trim().toLowerCase();
      const productTitle = (thumb.getAttribute('data-product-title') || '').trim().toLowerCase();
      const correspondingSlide = slides[index];
      const correspondingDot = dots[index];

      // If it's a generic image (alt is empty or equals product title), always show it
      let shouldShow = !altText || altText === productTitle;

      // Otherwise, see if any of the selected values match the alt text (exact or comma-separated list)
      if (!shouldShow && selectedValues) {
        selectedValues.forEach((val) => {
          if (!val) return;
          const cleanVal = val.trim().toLowerCase();
          const altParts = altText.split(',').map(p => p.trim());
          if (cleanVal === altText || altParts.includes(cleanVal)) {
            shouldShow = true;
          }
        });
      }

      console.log("thumb:", thumb.dataset.galleryThumb, "altText:", altText, "shouldShow:", shouldShow);

      if (shouldShow) {
        thumb.style.display = '';
        if (correspondingSlide) correspondingSlide.style.display = '';
        if (correspondingDot) correspondingDot.style.display = '';
        if (!firstVisibleThumb) {
          firstVisibleThumb = thumb;
        }
        if (thumb.classList.contains('active')) {
          activeThumbIsVisible = true;
        }
        if (featuredImageUrl && thumb.dataset.galleryThumb === featuredImageUrl) {
          matchedFeaturedThumb = thumb;
        }
      } else {
        thumb.style.display = 'none';
        if (correspondingSlide) correspondingSlide.style.display = 'none';
        if (correspondingDot) correspondingDot.style.display = 'none';
      }
    });

    // Update active thumb
    if (matchedFeaturedThumb) {
      thumbs.forEach((btn) => btn.classList.remove('active'));
      matchedFeaturedThumb.classList.add('active');
    } else if (!activeThumbIsVisible && firstVisibleThumb) {
      thumbs.forEach((btn) => btn.classList.remove('active'));
      firstVisibleThumb.classList.add('active');

      const slidesContainer = document.querySelector('.product-gallery__slides');
      if (slidesContainer) {
        const targetSlide = Array.from(slidesContainer.children).find(
          (slide) => slide.dataset.imageUrl === firstVisibleThumb.dataset.galleryThumb
        );
        if (targetSlide) {
          slidesContainer.scrollTo({
            left: targetSlide.offsetLeft,
            behavior: 'smooth'
          });
        }
      } else {
        const mainImg = document.querySelector('[data-gallery-main]');
        if (mainImg) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = firstVisibleThumb.dataset.galleryThumb;
        }
      }
    }
  }

  function initVariantSelectors() {
    const containers = document.querySelectorAll('[data-product-variants-container]');
    containers.forEach((container) => {
      const select = container.querySelector('[data-product-select]');
      const boxes = container.querySelectorAll('.variant-box');
      if (!select || !boxes.length) return;

      const updateGallery = (imageUrl) => {
        const selectedValues = [];
        container.querySelectorAll('.variant-option').forEach((opt) => {
          const activeBox = opt.querySelector('.variant-box.active');
          selectedValues.push(activeBox ? activeBox.dataset.optionValue : '');
        });
        filterGallery(selectedValues, imageUrl);
      };

      boxes.forEach((box) => {
        box.addEventListener('click', () => {
          const optionIndex = box.closest('.variant-option').dataset.optionIndex;
          const value = box.dataset.optionValue;

          // Remove active class from sibling boxes in the same option group
          box.closest('.variant-option').querySelectorAll('.variant-box').forEach((btn) => btn.classList.remove('active'));
          box.classList.add('active');

          // Find currently selected option values
          const selectedValues = [];
          container.querySelectorAll('.variant-option').forEach((opt) => {
            const activeBox = opt.querySelector('.variant-box.active');
            selectedValues.push(activeBox ? activeBox.dataset.optionValue : '');
          });

          // Match the chosen option values to a variant
          let matchedOption = null;
          Array.from(select.options).forEach((opt) => {
            let match = true;
            selectedValues.forEach((val, idx) => {
              if (opt.getAttribute(`data-option${idx}`) !== val) {
                match = false;
              }
            });
            if (match) matchedOption = opt;
          });

          if (matchedOption) {
            select.value = matchedOption.value;

            const variantId = matchedOption.value;
            const available = matchedOption.getAttribute('data-available') === 'true';

            // Update Add to Cart / Buy Now buttons
            const addBtn = document.querySelector('[data-add-to-cart]');
            const buyBtn = document.querySelector('[data-buy-now]');
            if (addBtn) {
              addBtn.dataset.addToCart = variantId;
              addBtn.disabled = !available;
              addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
            }
            if (buyBtn) {
              buyBtn.dataset.buyNow = variantId;
              buyBtn.disabled = !available;
              buyBtn.style.display = available ? '' : 'none';
            }

            // Update main prices
            const price = Number(matchedOption.getAttribute('data-price') || 0);
            const comparePrice = Number(matchedOption.getAttribute('data-compare-price') || 0);

            const priceCurrent = document.querySelector('.pp-price__current');
            const priceAlt = document.querySelector('.product-page__price-alt');

            if (priceCurrent) priceCurrent.dataset.moneyConvert = price;
            if (priceAlt) priceAlt.dataset.moneyConvert = price;

            // Handle MRP row show/hide
            let mrpRow = document.querySelector('.pp-price__mrp-row');
            let mrpNode = document.querySelector('.pp-price__mrp');
            let discountBadge = document.querySelector('[data-discount-badge]');

            if (comparePrice > price) {
              // Create MRP row if it doesn't exist
              if (!mrpRow) {
                mrpRow = document.createElement('div');
                mrpRow.className = 'pp-price__mrp-row';
                mrpRow.innerHTML = '<span class="pp-price__mrp-label">M.R.P.:</span><span class="pp-price__mrp" data-money-mode="primary"></span>';
                const wrapper = document.querySelector('.product-page__price-wrapper');
                const offerRow = document.querySelector('.pp-price__offer-row');
                if (wrapper && offerRow) wrapper.insertBefore(mrpRow, offerRow.nextSibling);
                mrpNode = mrpRow.querySelector('.pp-price__mrp');
              }
              if (mrpNode) mrpNode.dataset.moneyConvert = comparePrice;
              mrpRow.style.display = '';

              // Show discount badge
              const savePct = Math.round(((comparePrice - price) / comparePrice) * 100);
              if (!discountBadge) {
                discountBadge = document.createElement('span');
                discountBadge.className = 'pp-price__discount-badge';
                discountBadge.setAttribute('data-discount-badge', '');
                const wrapper = document.querySelector('.product-page__price-wrapper');
                if (wrapper) wrapper.insertBefore(discountBadge, wrapper.firstChild);
              }
              discountBadge.textContent = `-${savePct}%`;
              discountBadge.style.display = '';
            } else {
              if (mrpRow) mrpRow.style.display = 'none';
              if (discountBadge) discountBadge.style.display = 'none';
            }

            // Update gallery image if variant has a featured image
            const imageUrl = matchedOption.getAttribute('data-image');
            const slidesContainer = document.querySelector('.product-gallery__slides');
            if (imageUrl && slidesContainer) {
              const targetSlide = Array.from(slidesContainer.children).find(
                (slide) => slide.dataset.imageUrl === imageUrl
              );
              if (targetSlide) {
                slidesContainer.scrollTo({
                  left: targetSlide.offsetLeft,
                  behavior: 'smooth'
                });
              }
            } else if (imageUrl) {
              const mainImg = document.querySelector('[data-gallery-main]');
              if (mainImg) {
                mainImg.removeAttribute('srcset');
                mainImg.removeAttribute('sizes');
                mainImg.src = imageUrl;
              }
            }

            // Update weight / variant name metadata
            const metaVar = document.querySelector('.product-page__meta-variant');
            if (metaVar) {
              metaVar.textContent = matchedOption.text.trim();
            }

            // Update stock count display
            const inventory = Number(matchedOption.getAttribute('data-inventory') || 0);
            const management = matchedOption.getAttribute('data-management');
            const stockCounter = document.querySelector('.stock-counter');
            if (stockCounter) {
              if (management === 'shopify' && inventory < 25 && inventory > 0) {
                stockCounter.innerHTML = `<span class="stock-dot"></span>Only ${inventory} left in stock`;
                stockCounter.style.display = '';
              } else {
                stockCounter.style.display = 'none';
              }
            }

            // Filter the gallery thumbnails
            updateGallery(imageUrl);

            // Re-trigger currency toggle converter
            const activeCurrency = localStorage.getItem(STORAGE_KEYS.currency) || 'INR';
            setCurrency(activeCurrency);
          }
        });
      });

      // Run initially on page load to match the first active variant
      const initialMatchedOpt = select.options[select.selectedIndex];
      const initialImageUrl = initialMatchedOpt ? initialMatchedOpt.getAttribute('data-image') : null;
      updateGallery(initialImageUrl);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncementBar();
    initHeaderScroll();
    initHeroSlider();
    initCurrencyToggle();
    initAOS();
    initFilters();
    initAccordions();
    initProductGallery();
    initQuantityControls();
    initCartActions();
    initMobileMenu();
    initQuickView();
    initVariantSelectors();
  });
})();
